import { type TFunction } from "i18next";
import { type FieldValues, type UseFormGetValues } from "react-hook-form";
import { type ValidationOptions } from "@/components/common/formElements/types";

export function transformValidationOptions<TFieldValues extends FieldValues>(
  t: TFunction,
  validation: ValidationOptions<TFieldValues> = {},
  getValues?: UseFormGetValues<TFieldValues>,
) {
  const rules = { ...validation };

  if (rules.required === true) {
    rules.required = t("validation.error.code.REQUIRED");
  }

  if (typeof rules.min === "number") {
    rules.min = {
      value: rules.min,
      message: t("validation.error.code.INVALID_MIN_VALUE", {
        0: rules.min,
      }),
    };
  }

  if (typeof rules.max === "number") {
    rules.max = {
      value: rules.max,
      message: t("validation.error.code.INVALID_MAX_VALUE", {
        0: rules.max,
      }),
    };
  }

  if (rules.match && rules.match.name && getValues) {
    const fieldName = rules.match.name;
    const errorMessage = rules.match.message;

    rules.validate = {
      isMatch(value) {
        return getValues(fieldName) === value || errorMessage || false;
      },
      ...rules.validate,
    };
  }

  return rules;
}
